/**
 * Campo per il codice di verifica di un attestato: maiuscolo, solo lettere e cifre,
 * 12 caratteri mostrati a gruppi di 4 (ABCD-EFGH-2345), font mono.
 */
import { forwardRef, type ChangeEvent } from 'react';
import { TextField, type TextFieldProps } from './TextField.js';

export const LUNGHEZZA_CODICE = 12;

/** Normalizza: maiuscolo, senza caratteri estranei, al massimo 12. */
export function normalizzaCodice(input: string): string {
  return input.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, LUNGHEZZA_CODICE);
}

/** Mostra il codice a gruppi di 4 separati da trattino, anche mentre si scrive. */
export function formattaInputCodice(input: string): string {
  return normalizzaCodice(input).replace(/(.{4})(?=.)/g, '$1-');
}

export interface CodiceVerificaFieldProps extends Omit<TextFieldProps, 'value' | 'onChange' | 'mono'> {
  /** valore normalizzato (senza trattini) */
  value: string;
  onValueChange: (codice: string) => void;
}

export const CodiceVerificaField = forwardRef<HTMLInputElement, CodiceVerificaFieldProps>(function CodiceVerificaField({ value, onValueChange, ...rest }, ref) {
  function onChange(e: ChangeEvent<HTMLInputElement>) {
    onValueChange(normalizzaCodice(e.target.value));
  }
  return (
    <TextField
      ref={ref}
      mono
      value={formattaInputCodice(value)}
      onChange={onChange}
      autoCapitalize="characters"
      autoComplete="off"
      spellCheck={false}
      inputMode="text"
      maxLength={LUNGHEZZA_CODICE + 2}
      meta={`${value.length} di ${LUNGHEZZA_CODICE}`}
      {...rest}
    />
  );
});
